import React from 'react'
import styles from './statusbar.module.scss'
import clsx from 'clsx'
import Icon from '../../Icon'
import * as PropTypes from 'prop-types'

const NotificationsStatusBar = ({
  view = 'l',
  className = '',
  children = null,
  onClose = null,
  after = null,
  before = null,
  color = 'basic-primary-blue',
  ...rest
}) => (
  <div
    {...rest}
    className={clsx(
      className,
      styles['notifications-statusbar'],
      styles[`notifications-statusbar_view-${view}`],
      {
        [`bg-color-${color}`]: color,
      },
    )}
  >
    {before && (
      <div className={styles['notifications-statusbar__before']}>{before}</div>
    )}
    <div className={styles['notifications-statusbar__content']}>{children}</div>
    {after && (
      <div className={styles['notifications-statusbar__after']}>{after}</div>
    )}
    {onClose && typeof onClose === 'function' && (
      <span
        onClick={onClose}
        className={styles['notifications-statusbar__close-btn']}
      >
        <Icon name={'close'} color={'basic-primary-white'} size={'m'} />
      </span>
    )}
  </div>
)

NotificationsStatusBar.propTypes = {
  view: PropTypes.oneOf(['s', 'm', 'l']),
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
    PropTypes.oneOf([null]),
  ]),
  after: PropTypes.oneOfType([PropTypes.element, PropTypes.oneOf([null])]),
  before: PropTypes.oneOfType([PropTypes.element, PropTypes.oneOf([null])]),
  onClose: PropTypes.oneOfType([PropTypes.func, PropTypes.oneOf([null])]),
  color: PropTypes.string,
}

export default NotificationsStatusBar
